export default __webpack_public_path__ + "static/media/optimity-setup.cd01f39a.png";